export enum LeaveReasons {
  DontDoTheTripsAnymore = 0,
  DoTheTripsByOtherMeans = 1,
  NotHappyWithTheService = 2,
  Other = 3
}